import ShippingMethod from 'components/FrictionlessCheckout/ShippingMethods/ShippingMethod/ShippingMethod';

export default ShippingMethod;
